import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import React from "react";

const AreYouSureDialog = ({ open, setOpen, actionText, onDelete, title }) => {
  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      fullWidth
      slotProps={{
        paper: {
          component: "form",
          sx: { backgroundImage: "none" },
        },
      }}
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Typography variant={"body1"}>
          Are you sure {actionText}? This can not be undone.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setOpen(false)} variant={"outlined"}>
          Cancel
        </Button>
        <Button onClick={onDelete} variant={"contained"}>
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AreYouSureDialog;
